<template>
  <div class="special">
    <div class="intro" v-for="(item, index) in list" :key="index">
      <div class="left">
        <img class="line" src="../../assets/index/line.png" alt="" />
        <div class="title">{{ item.title }}</div>
        <!--                <div class="subTitle">整窗五年质保、终身免费售后</div>-->

        <div class="wrap" style="padding-bottom: 48px">
          <div class="wrapDesc">
            {{ item.desc }}
          </div>
          <div class="pic"><img :src="item.image" alt="" /></div>
        </div>
      </div>
    </div>

    <!-- <div class="part2">
      <div class="intro">
        <div class="left">
          <img class="line" src="../../assets/index/line.png" alt="" />
          <div class="title">暖冬服务</div>
        </div>
      </div>
      <div class="wrap">
        <div class="wrapDesc">
          因胶条等个别配件属于消耗品，因天气或磨损可能会导致门窗密封性降低，影响冬天保温性能。阁韵会追踪您的订单时间，根据您的所在地区，在一定年限后对消费者进行回访，询问是否需要免费的胶条更换服务，让阁韵铝包木窗陪您度过每一个温暖的冬日。
        </div>
        <div class="pic">
          <img src="../../assets/service/spe2.png" alt="" />
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { feature } from "../../api/request";

export default {
  name: "ServiceSpecial",
  data() {
    return {
      active: 0,
      list: [
        // {
        //   id: 0,
        //   name: "微信公众平台\n" + "咨询报修",
        //   img: require("../../assets/service/return1.png"),
        //   desc: "扫描二维码或搜索阁韵铝包木窗（ID：grunen），添加阁韵铝包木窗官方微信公众服务号，点击屏幕右下角的“客户中心”菜单项，进入咨询页面输入问题描述并发送，常见问题可选择知识库查询，复杂问题或其他投诉建议可以转人工。",
        // },
        // {
        //   id: 0,
        //   name: "官方网站\n" + "咨询报修",
        //   img: require("../../assets/service/return2.png"),
        //   desc: "在浏览器中搜索阁韵木窗或阁韵窗业有限公司，或直接点击官网页面右侧咨询按钮，进入咨询页面，在输入框内键入问题描述并发送，常见问题常见问题可选择知识库查询，复杂问题或其他投诉建议可以转人工。\n",
        // },
        // {
        //   id: 0,
        //   name: "官网400\n" + "客户服务热线",
        //   img: require("../../assets/service/return3.png"),
        //   desc:
        //     "拨打阁韵窗业有限公司官方客服电话：400-8777-918，按语音提示进行转接，报修并解决问题\n" +
        //     "   \n" +
        //     "我们将竭诚为全部消费者服务！\n",
        // },
      ],
    };
  },
  mounted() {
    feature().then((res) => {
      if (res.data.code == 1) {
        // console.log(res.data.data);
        this.list = res.data.data;
      }
    });
  },
  methods: {
    change(index) {
      console.log(index);
      this.active = index;
    },
    handleMouse(index) {
      this.active = index;
    },
  },
};
</script>

<style scoped lang="less">
.special {
  font-family: 微软雅黑, MicrosoftYaHei;
  .intro {
    padding-bottom: 42px;
    width: 1280px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    border-bottom: 1px dotted #f5f5f5;
    .left {
      text-align: left;
    }
    .line {
      width: 90px;
      height: 8px;
    }
    .title {
      font-size: 42px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: bold;
      color: #004c31;
      margin-top: 38px;
    }
    .subTitle {
      margin-top: 24px;
      font-size: 24px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: 400;
      color: #004c31;
    }
    .right {
      text-align: justify;
      width: 960px;
      .gc {
        margin-top: 70px;
        font-size: 20px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #004c31;
        line-height: 36px;
      }
    }
  }
  .wrap {
    width: 1280px;
    margin: 50px auto 0;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .wrapDesc {
      text-align: left;
      width: 433px;
      font-size: 20px;
      color: #6c7a77;
    }
    .pic {
      width: 782px;
      height: 348px;
      img {
        width: 782px;
        height: 348px;
      }
    }
  }
  .part2 {
    background: #f5f5f5;
    width: 100%;
    padding: 99px 0;
  }
}
@media screen and (max-width: 450px) {
  .special {
    font-family: 微软雅黑, MicrosoftYaHei;
    .intro {
      padding-top: 59px;
      padding-bottom: 42 * 2px;
      width: 1280px;
      margin: 0 auto;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      border-bottom: 1px dotted #f5f5f5;
      .left {
        text-align: left;
      }
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 38 * 2px;
      }
      .subTitle {
        margin-top: 24 * 2px;
        font-size: 24 * 2px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #004c31;
      }
      .right {
        text-align: justify;
        width: 960px;
        .gc {
          margin-top: 70 * 2px;
          font-size: 20 * 2px;
          font-family: 微软雅黑, MicrosoftYaHei;
          font-weight: 400;
          color: #004c31;
          line-height: 36px;
        }
      }
    }
    .wrap {
      width: 1280px;
      margin: 50px auto 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .wrapDesc {
        text-align: left;
        width: auto;
        font-size: 20 * 2px;
        color: #6c7a77;
      }
      .pic {
        margin-top: 32px;
        width: 782 * 2px;
        height: 348 * 2px;
        img {
          width: 782 * 2px;
          height: 348 * 2px;
        }
      }
    }
    .part2 {
      background: #f5f5f5;
      width: 100%;
      padding: 99px 0;
    }
  }
}
</style>
